import React from 'react';
import { useAppDispatch } from 'redux/hooks';
import { useNavigate } from 'react-router-dom';
import { postNewRecentSearch } from 'services/discounts';
import { ISearchDiscount } from 'interfaces/search.model';
import { AnalyticsEvents } from 'enums';
import { captureEvent } from 'utils/analytics/captureEvent';
import { Text } from 'view/atoms';
import { useCurrentUser, useDebounce, useMediaQuery } from 'hooks';
import { bonus, close } from 'static/icons/resizable';
import { ROUTES } from 'config';
import { deleteRecentSearchByID } from 'redux/modules/Discounts/discounts';
import mockImg from './mockImg.png';
import * as S from './SearchCard.styles';

export const SearchCard = ({
  image,
  title,
  type,
  discountId,
  sizeMax,
  isRecentSearch,
}: ISearchDiscount) => {
  const user = useCurrentUser();
  const [searchValue] = useDebounce(300);

  const { mobile, tablet } = useMediaQuery();

  const isMobile = mobile || tablet;

  const id = discountId.toString();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const deleteRecentByID = (e: React.MouseEvent) => {
    e.stopPropagation();
    dispatch(deleteRecentSearchByID(id));
  };

  const goToDiscountPage = () => {
    postNewRecentSearch(discountId);
    if (user?.id) {
      captureEvent(AnalyticsEvents.SearchAutocomplete, {
        user_id: String(user.id),
        search_term: title,
        search_type: 'autocomplete',
        event_time: new Date().toISOString(),
      });
    }

    navigate(`${ROUTES.discountRoot}/${discountId}`);
  };

  return (
    <S.SearchCard onClick={goToDiscountPage}>
      <S.LeftSideBox>
        {isMobile && <S.IMGCard src={image || mockImg} alt='img card' />}

        <S.TextBox>
          <Text kind='h4' color='gray1'>
            {title}
          </Text>

          <Text kind='small1' color='gray2'>
            {type}
          </Text>
        </S.TextBox>
      </S.LeftSideBox>
      <S.Wrapper>
        {sizeMax ? (
          <Text kind={isMobile ? 'h3' : 'h4'} color='gray1'>
            {`${sizeMax}%`}
          </Text>
        ) : (
          <S.ImageBonus src={bonus} alt='Gift icon' />
        )}
        {isRecentSearch && (
          <S.IconStyled
            src={close}
            onClick={deleteRecentByID}
            className='safe-to-click'
          />
        )}
      </S.Wrapper>
    </S.SearchCard>
  );
};
